import { Component, OnInit, ViewChild } from "@angular/core";
import { ConnectService } from "@app/shared/services/connect.service";
import swal from "sweetalert2";
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { MessageTimeZonePipe } from "@app/shared/pipes/message-time-zone.pipe";
import { Router } from "@angular/router";
import { CountdownComponent } from "ngx-countdown";


@Component({
  selector: "app-messages-list",
  templateUrl: "./messages-list.component.html",
  styleUrls: ["./messages-list.component.css"],
  providers: [DatePipe, MessageTimeZonePipe]
})
export class MessagesListComponent implements OnInit {
  groupList: any = [];
  selectedChatDetails: any = {};
  recipientGroupId: any = null;
  searchList: any = [];

  searchText: string = "";
  receiverId: any = null;
  messageText: string = "";
  messageList: any = [];
  showNewMessage: boolean = false;
  selectedIndex = 0;
  groupSearchText: string = "";
  disabledMessage: boolean = true;
  groupId: any;
  constructor(private connectService: ConnectService,
    private router: Router, private messageTimeZonePipe: MessageTimeZonePipe) {
    this.groupId = localStorage.getItem('userIDFromNxtPage');
    localStorage.removeItem('userIDFromNxtPage');
  }
  @ViewChild(CountdownComponent) counter: CountdownComponent;

  ngOnInit() {
    this.selectedIndex = 0;
    if (this.groupId) {
      this.createGroup(this.groupId);
    } else {
      this.getGroupList();
    }
  }
  getGroupList(groupId?: any) {
    this.connectService.getGroupList().subscribe(
      (data: any) => {
        this.groupList = data;
        if (groupId) {
          let findGroupIndex = this.groupList.findIndex(x => x.id == groupId);
          if (findGroupIndex > -1) {
            this.selectedIndex = findGroupIndex;
          }
          this.getMessages(
            this.groupList[this.selectedIndex].id,
            this.groupList[this.selectedIndex].receiverDetail.id,
            this.selectedIndex
          );
        }
        if (this.selectedIndex === 0) {
          this.getMessages(
            this.groupList[this.selectedIndex].id,
            this.groupList[this.selectedIndex].receiverDetail.id,
            this.selectedIndex
          );
        }
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }

  routeTechAnalystProfilePage(analystId: string) {
    this.router.navigate(["analyst-profile"], {
      queryParams: { analystId: analystId }
    });
  }
  getAllRequestList(event, status) {
    if (this.searchText) {
      this.connectService
        .getMyConnectionList(status, this.searchText)
        .subscribe((data: any) => {
          this.searchList = data.data;
        }),
        error => {
          swal("Info", error.error.error.message, "info");
        };
    } else {
      this.searchList = [];
    }
  }
  createGroup(id) {
    this.connectService.createGroup(id).subscribe(
      (resp: any) => {
        this.showNewMessage = false;
        this.getGroupList(resp.id);
        this.searchText = '';
        this.searchList = [];
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }

  countMakezero(groupId, receiverId, index) {
    this.groupList[index].unreadCount = 0;
    if (index > 0) {
      this.groupList[0].unreadCount = 0;

    }
  }
  getMessages(groupId, receiverId, index) {
    this.showNewMessage = false;
    this.selectedIndex = index;
    this.recipientGroupId = groupId;
    this.receiverId = receiverId;

    this.connectService
      .getMessages(this.recipientGroupId, receiverId)
      .subscribe(
        (data: any) => {
          if (data.data.length > 0) {
            let formatArray: any[] = data.data.map(item => {
              return { messageContent: item.messageContent, senderId: item.senderId, createdAt: item.createdAt, formatedDate: this.messageTimeZonePipe.transform(item.createdAt) };
            });
            this.messageList = _.chain(formatArray).groupBy("formatedDate").map((v, i) =>
              ({
                date: i,
                messageData: v
              })).valueOf();
            setTimeout(function () {
              const chatView = document.getElementsByClassName("message-body")[0];
              chatView.scrollTop = chatView.scrollHeight;
            }, 100);
          }
          else {
            this.messageList = [];
          }
        },
        error => {
          swal("Info", error.error.error.message, "info");
        }
      );
  }
  refreshMessage() {
    this.connectService
    .getMessages(this.recipientGroupId, this.receiverId)
    .subscribe(
      (data: any) => {
        if (data.data.length > 0) {
          let formatArray: any[] = data.data.map(item => {
            return { messageContent: item.messageContent, senderId: item.senderId, createdAt: item.createdAt, formatedDate: this.messageTimeZonePipe.transform(item.createdAt) };
          });
          this.messageList = _.chain(formatArray).groupBy("formatedDate").map((v, i) =>
            ({
              date: i,
              messageData: v
            })).valueOf();
          setTimeout(function () {
            const chatView = document.getElementsByClassName("message-body")[0];
            chatView.scrollTop = chatView.scrollHeight;
          }, 100);
        }
        else {
          this.messageList = [];
        }
        this.counter.restart();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }
  sendMessage() {

    this.groupList[this.selectedIndex].unreadCount = 0;

    let data = {
      messageContent: this.messageText
    };
    this.connectService
      .postMessage(this.recipientGroupId, this.receiverId, data)
      .subscribe(
        (resp: any) => {
          this.messageText = "";
          this.getMessages(this.recipientGroupId, this.receiverId, this.selectedIndex);
          this.getGroupList();
        },
        error => {
          swal("Info", error.error.error.message, "info");
        }
      );
  }
  messageOnChnage(event) {
    if (/^\s+$/.test(event)) {
      this.disabledMessage = true;
    }
    else {
      this.disabledMessage = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/messages-list/messages-list.component.ts